export default __webpack_public_path__ + "static/media/na.9eba8edf.svg";